import DpsListItem from './DpsListItem';

export default DpsListItem;
